import React from "react"
import { Form, Input } from 'antd';
import { AiOutlineLock } from "react-icons/ai";

import classes from './CreateConfirmPassword.module.scss'

export const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!-/:-@[-`{-~])[A-Za-z\d!-/:-@[-`{-~]{8,30}$/

export const CreateConfirmPasswordComponent = ({newPassword, confirmedPassword, setNewPassword, setConfirmedPassword}) => {
    return <React.Fragment>
        <Form.Item>
            <div className={classes.extra}>
                {`Пароль должен быть длиной от 8 до 30 символов, состоять из `}
                <b>латинских букв</b>
                {` верхнего и нижнего регистров и включать `}
                <b>цифры и спец. символы</b>.
            </div>
        </Form.Item>
        <Form.Item
            name="password"
            label="Пароль"
            rules={[
                { required: true, message: 'Данное поле является обязательным!' },
                {
                    pattern: passwordPattern,
                    message: 'Некорректный формат пароля'
                }
            ]}>
            <Input.Password
                prefix={<AiOutlineLock />}
                placeholder="Новый пароль"
                value={newPassword}
                onChange={setNewPassword} />
        </Form.Item>

        <Form.Item
            name="confirmPassword"
            label="Подтвердите пароль"
            rules={[
                { required: true, message: 'Данное поле является обязательным!' },
                ({ getFieldValue }) => ({
                    validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('Пароли должны совпадать!'));
                    },
                }),
            ]}>
            <Input.Password
                prefix={<AiOutlineLock />}
                placeholder="Подтвердите пароль"
                value={confirmedPassword}
                onChange={setConfirmedPassword} />
        </Form.Item>
    </React.Fragment>
}